// import React from "react";
// import "./styles/ContactUs.css";
// import { motion } from "framer-motion";
// import { Phone, Calendar } from "lucide-react";
// import PageTitle from "../components/PageTitle";

// import contactImage from '../assets/images/contact-right-iamge.webp';
// import ContactForm from "../components/individual/ContactForm";

// const Contact = () => {
//   return (
//     <>
//       <PageTitle
//         title="Contact Us"
//         description="Get in touch with DG Future Tech. We're here to answer your questions and provide the IT support you need."
//       />
//       <div className="contact-page-wrapper">
//         <motion.div
//           className="contact-container"
//           initial={{ opacity: 0 }}
//           animate={{ opacity: 1 }}
//           transition={{ duration: 0.5 }}
//         >
//           <h1 className="heading">Contact Us</h1>

//           <p className="description">
//             Reach Out for Reliable, Scalable IT Solutions.<br />
//             Looking for a trusted IT partner? Reach out today and discover how
//             we can support your business success.
//           </p>

//           <div className="contact-rectangles-container">
//             <div className="rectangle rectangle-1">
//               <div className="rectangle-content">
//                 <Phone className="contact-icon" />
//                 <h3 className="contact-title">Call Us</h3>
//                 <p className="contact-text">
//                   Available 24x7 for your support needs
//                 </p>
//               </div>
//               {/* FIX 1 — window.location.href → globalThis.location.href */}
//               <button
//                 className="contact-button"
//                 onClick={() => (globalThis.location.href = "tel:+91 198")}
//               >
//                 Call Now
//               </button>
//             </div>

//             <div className="rectangle rectangle-3">
//               <div className="rectangle-content">
//                 <Calendar className="contact-icon" />
//                 <h3 className="contact-title">Schedule Meeting</h3>
//                 <p className="contact-text">Book a meeting with our team</p>
//               </div>

//               {/* FIX 2 — window.open → globalThis.open with noopener,noreferrer */}
//               <button
//                 onClick={() =>
//                   globalThis.open(
//                     "https://calendly.com/rachna-kolhapure-dgfuturetech/30min?month=2025-04",
//                     "_blank",
//                     "noopener,noreferrer"
//                   )
//                 }
//                 className="contact-button"
//               >
//                 Schedule
//               </button>
//             </div>
//           </div>

//           <img
//             src={contactImage}
//             alt="Customer Support"
//             className="person-image"
//           />
//         </motion.div>
//         <ContactForm />
//       </div>
//     </>
//   );
// };

// export default Contact;






import React from "react";
import "./styles/ContactUs.css";
import PageTitle from "../components/PageTitle";
import ContactForm from "../components/individual/ContactForm";

const offices = [
  {
    country: "India",
    flag: "🇮🇳",
    company: "DG FutureTech India Pvt. Ltd.",
    address: "Gokhale Sanchit, 2F, 846 ,BMCC Rd, Shivajinagar, Pune 411004, India",
    mapEmbed: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3783.2033262746622!2d73.83779729999999!3d18.5197117!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bc2bf1d1ae843cb%3A0x8d00c432536a3548!2sDG%20FutureTech%20India%20Pvt%20Ltd!5e0!3m2!1sen!2sin!4v1743652739656!5m2!1sen!2sin",
  },
  {
    country: "Japan",
    flag: "🇯🇵",
    company: "Digital Garage",
    address: "Digital Gate Bldg., 3-5-7 Ebisu Minami, Shibuya-ku, Tokyo 150-0022, Japan",
    mapEmbed: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3242.2485933755306!2d139.7036923!3d35.64624639999999!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x60188b4689f7a449%3A0x662273f7372970f3!2sDigital%20Garage!5e0!3m2!1sen!2sin!4v1746602211128!5m2!1sen!2sin",
  },
  ];

const Contact = () => {
  return (
    <>
      <PageTitle
        title="Contact Us"
        description="Get in touch with DG Future Tech. We're here to answer your questions and provide the IT support you need."
      />

      <div className="contact-page-wrapper">

        {/* Contact Form */}
        <ContactForm />

        {/* Office Locations */}
<div className="office-locations-section">
  <h2 className="office-locations-title">Our Offices</h2>
  <div className="office-cards-grid">
    {offices.map((office, i) => (
      <div key={i} className="office-card">
        {/* Map on top */}
        <div className="office-map-container">
          <iframe
            title={`${office.country} office location`}
            src={office.mapEmbed}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          ></iframe>
        </div>
        {/* Address below */}
        <div className="office-card-body">
          <h3 className="office-country">{office.country}</h3>
          <h2 className="office-country">{office.company}</h2>
          <p className="office-address-text">
            <i className="fas fa-map-marker-alt"></i>
            {office.address}
          </p>
        </div>
      </div>
    ))}
  </div>
</div>

      </div>
    </>
  );
};
export default Contact;




